import { render, staticRenderFns } from "./UnplannedOutageResult.vue?vue&type=template&id=10191413"
import script from "./UnplannedOutageResult.vue?vue&type=script&lang=js"
export * from "./UnplannedOutageResult.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports